{
  "REGISTER": {
    "TRY_WOOT": "تسجيل حساب",
    "TITLE": "تسجيل",
    "TESTIMONIAL_HEADER": "إن كل ما يلزم هو خطوة واحدة للمضي قدما",
    "TESTIMONIAL_CONTENT": "You're one step away from engaging your customers, retaining them and finding new ones.",
    "TERMS_ACCEPT": "من خلال التسجيل، فإنك توافق على <a href=\"https://chat.jarabot.com/terms\">شروط الخدمة</a> و <a href=\"https://chat.jarabot.com/privacy-policy\">سياسة الخصوصية</a>",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">الشروط والأحكام</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">سياسة الخصوصية</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Sign up with Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Company name",
      "PLACEHOLDER": "Enter your company name. eg: Wayne Enterprises",
      "ERROR": "Company name is too short"
    },
    "FULL_NAME": {
      "LABEL": "الاسم الكامل",
      "PLACEHOLDER": "أدخل اسمك الكامل. مثال: بروس وين",
      "ERROR": "الاسم الكامل قصير جداً"
    },
    "EMAIL": {
      "LABEL": "البريد الإلكتروني للعمل",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Please enter a valid work email address"
    },
    "PASSWORD": {
      "LABEL": "كلمة المرور",
      "PLACEHOLDER": "كلمة المرور",
      "ERROR": "كلمة المرور قصيرة جداً",
      "IS_INVALID_PASSWORD": "يجب أن تحتوي كلمة المرور على الأقل على حرف كبير واحد وحرف صغير واحد ورقم واحد وحرف خاص واحد"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "تأكيد كلمة المرور",
      "PLACEHOLDER": "تأكيد كلمة المرور",
      "ERROR": "كلمة المرور غير متطابقة"
    },
    "API": {
      "SUCCESS_MESSAGE": "تم التسجيل بنجاح",
      "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
    },
    "SUBMIT": "إرسال",
    "HAVE_AN_ACCOUNT": "هل لديك حساب مسبق؟"
  }
}
